import { Component, OnInit } from '@angular/core';
import { Product } from '../../libs/proto/shop_pb';
import { ActivatedRoute, Router } from '@angular/router';
import { GrpcProductLibService } from '../../service/grpc/product/grpc-product-lib.service';
import { UserLibService } from '../../service/user/user-lib.service';
import { TranslateService } from '@ngx-translate/core';
import { Color, Language } from '../../libs/proto/commUnity_pb';
import { desktopMode } from '../../config/type';
import { DeviceLibService } from 'src/app/service/device/device-lib.service';
import { ColorConversionService } from 'src/app/service/conversion/color/color-conversion.service';

export interface SizeStock {
  size: string;
  qty: number;
}
export interface ColorVariant {
  label: string;
  bgcolor: string;
  fgcolor: string;
  totalQty: number;
  sizes: SizeStock[];
}
@Component({
  selector: 'app-product',
  templateUrl: './product.component.html',
  styleUrls: ['./product.component.sass']
})
export class ProductComponent implements OnInit {

  product: Product;
  colors: {k?: string, v?: string} = {};
  T = {};
  imageObject: Array<object> = [];
  imageSize: object = {};

  landscapeEvt = window.matchMedia('(orientation: landscape)');
  isLandscape = false;
  selectedColor: string | null = null;
  colorVariants: ColorVariant[] = [];
  colorImages: {[key: string]: string} = {};
  selectedSize: string | null = null;

  menuType = 0;

  constructor(
    private route: Router,
    private actRoute: ActivatedRoute,
    private userLib: UserLibService,
    private grpcProductLib: GrpcProductLibService,
    private translate: TranslateService,
    private detector: DeviceLibService,
    private colorlib: ColorConversionService,
  ) { }
  get currencysymbol() {
    return this.userLib.Data.token?.getCustomer().getCurrencysymbol();
  }
  ngOnInit(): void {
    const thise = this;
    this.actRoute.paramMap.subscribe( p => {
      thise.grpcProductLib.getProducts({
        Offline: true,
        call: {
          req: p.get('id'),
        }
      }).then( ns => {
        if (ns.length === 0) {
          this.route.navigateByUrl('/shop');
          return;
        }
        thise.product = ns[0];                
        let p = {
          product:thise.product,
          colorVariants: thise.colorVariants,
          colorImages: thise.colorImages,
          selectedColor: thise.selectedColor,
          selectedSize: '',
          userlang: thise.userLib.Data.token?.getProfile()?.getLanguage().toString(),
          colorlib: thise.colorlib,
        }
        buildVariantMatrix(p);
        this.colorVariants = p.colorVariants;
        this.colorImages = p.colorImages;
        this.selectedColor = p.selectedColor;
        console.log(p)

        if (this.userLib.Data.producstPage === undefined) {
          this.userLib.Data.producstPage = {};
        }
        thise.prepareImage();
      });
    });

    // keep key
    const tLists: string[] = [];
    Object.keys(Color).map( c => {
      this.colors[Color[c]] = c;
      tLists.push('colors.' + c);
    });

    this.imageSize = {
      width: '100%',
    };

    // translate
    this.translate.get(tLists).toPromise().then( t => {
      this.T = t;
    });

    this.isLandscape = this.detector.orientation === 'landscape';
    this.menuType = this.getmenuType();
    this.landscapeEvt.addEventListener('change', ev => {
      this.isLandscape = this.landscapeEvt.matches;
      this.menuType = this.getmenuType();
    });
  }
  private prepareImage() {
    let imgc:string[] = [this.colorImages[this.selectedColor || ''] || ''].filter( p => p.length > 0);
    (imgc.length > 0 ? imgc : ['assets/images/nophoto.png']).forEach( p => {
      this.imageObject.push(
        {
          image: p,
          thumbImage: p
        }
      );
    });
  }

  get backgroundColor() {
    return this.userLib.designToolbarBackgroundColor;
  }

  colorList(p?: Product): string {
    return p?.getColorsList().filter( v => v !== Color.COLOR_NO).map( v => (
      this.T['colors.' + this.colors[v]]
    )).join(',');
  }

  clickButton() {
    if (this.userLib.Data.token?.getProfile().getIsguest()) {
      this.userLib.clear();
      this.userLib.Data.signOut = true;
      this.route.navigateByUrl('/login');
      return;
    }
    this.route.navigate(['/product/confirm', this.product?.getId()], {
      'state': {
        'color': this.selectedColor,
        'size': this.selectedSize,
      }
    });
  }

  get hasColorSize() {
    let c = 0;
    if ((this.colorList(this.product)?.length || 0) > 0) { c++; }
    if ((this.product?.getSizesList().join(',') || '') !== '') { c++; }
    if ((this.product?.getUrl() || '') !== '') { c++; }

    return c;
  }

  get product_qty() {
    if (this.product && this.product.getQtyn()) {
       return this.product.getQt();
    }

    return '';
  }

  /**
   * menu type
   * - 0 = list
   * - 1 = box with image (2 cols)
   * - 2 = box with image (4 cols)
   */
   getmenuType() {
    // if not mobile, return default mobile
    if (!this.detector.isMobile()) {
      // if desktop mode = 3, force to use photo menu
      if (+desktopMode === 3) { return 1; }
      // if desktop mode = 4, force to use photo menu4
      if (+desktopMode === 4)  {
        if (this.isLandscape) { return 2;  }
        return 1;
      }

      return 0;
    }

    return this.userLib.Data.token?.getCustomer()?.getMobilemenutype();
  }

  selectColor(color: string): void {
    this.selectedColor = color;
    this.imageObject = [];
    this.prepareImage();
  }
  selectSize(size: string): void {
    this.selectedSize = size;
  }
  get activeVariantSizes(): SizeStock[] {
    const active = this.colorVariants.find(c => c.label === this.selectedColor);
    return active ? active.sizes : [];
  }
  isDark(hex: string): boolean {
  const c = hex.replace('#', '');
  const r = parseInt(c.substr(0, 2), 16);
  const g = parseInt(c.substr(2, 2), 16);
  const b = parseInt(c.substr(4, 2), 16);
  return (0.299 * r + 0.587 * g + 0.114 * b) < 150;
}
}
export interface VariantInterface {
  product: Product;
  colorVariants: ColorVariant[];
  selectedColor: string | null;
  selectedSize: string | null;
  userlang: string | undefined;
  colorlib: ColorConversionService,
  colorImages: Record<string, string>;
}
// Optimized single-pass processor: 1 loop over all variants/sizes
export function buildVariantMatrix(param: VariantInterface): void {
  if (!param.product) {
    param.colorVariants = [];
    param.selectedColor = null;
    return;
  }

  const variants = param.product.getVariantsList();
  if (!variants || variants.length === 0) {
    param.colorVariants = [];
    param.selectedColor = null;
    return;
  }

  const colorMap = new Map<string, { label: string; fg: string; bg: string; totalQty: number; sizeMap: Map<string, number> }>();
  const currentLang = param.userlang;

  const COLOR_NAME_MAP: Record<number, string> = Object.keys(Color).reduce((acc, key) => {
    const value = (Color as any)[key];
    if (typeof value === 'number') {
      acc[value] = key.replace(/^COLOR_/, '');
    }
    return acc;
  }, {} as Record<number, string>);

  variants.forEach((variant) => {
    const colorKey = String(variant.getColor()); // group by the actual color

    if (!colorMap.has(colorKey)) {
      let mclr = COLOR_NAME_MAP[Number(variant.getColor())]
      colorMap.set(colorKey, {
        label: mclr,
        fg: param.colorlib.fgColor(variant.getColor()),
        bg: param.colorlib.colorhtml(variant.getColor()),
        totalQty: 0,
        sizeMap: new Map()
      });
      param.colorImages[mclr] = variant.getImage();
    }
    const entry = colorMap.get(colorKey)!;

    variant.getSizesMap()?.forEach((sizeObj, sizeKey: string) => {
      const qty = sizeObj.getQt() || 0;

      // Localize the size's display label; fall back to the raw key if missing
      let sizeLabel = sizeKey || 'Standard';
      sizeObj.getLabelsMap()?.forEach((labelVal: string, labelKey: string) => {
        if (labelKey === currentLang) {
          sizeLabel = labelVal;
        }
      });

      entry.totalQty += qty;
      const existingSizeQty = entry.sizeMap.get(sizeLabel) || 0;
      entry.sizeMap.set(sizeLabel, existingSizeQty + qty);
    });
  });

  param.colorVariants = Array.from(colorMap, ([, data]) => ({
    label:  data.label,
    fgcolor: data.fg,
    bgcolor: data.bg,
    totalQty: data.totalQty,
    sizes: Array.from(data.sizeMap, ([size, qty]) => ({ size, qty }))
  }));

  const defaultAvailable = param.colorVariants.find(c => c.totalQty > 0);
  param.selectedColor = defaultAvailable ? defaultAvailable.label : (param.colorVariants[0]?.label || null);
  param.selectedSize = defaultAvailable?.sizes[0]?.size || (param.colorVariants[0]?.sizes[0]?.size || null);
}
